import classnames from 'classnames/bind'

import Information, {
  InformationProps,
} from '~/components/Account/Logged/InformationAndChangePassword/Information'
import { Customer } from '~/components/Account/Logged/types'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type InformationAndChangePasswordProps = {
  className?: string
  customer?: Customer
  information: InformationProps
}

function InformationAndChangePassword({
  className,
  customer,
  information,
}: InformationAndChangePasswordProps) {
  return (
    <div className={cx(className, css.InformationAndChangePassword)}>
      <Information customer={customer} {...information} />
    </div>
  )
}

InformationAndChangePassword.defaultProps = {}

export default InformationAndChangePassword
